import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import { KpiFilters } from '../../models/kpi-filters.model';
import { KpiService } from '../../services/kpi.service';

@Component({
  selector: 'app-kpi-stage-distribution',
  templateUrl: './kpi-stage-distribution.component.html',
  styleUrl: './kpi-stage-distribution.component.scss',
  standalone: false,
})
export class KpiStageDistributionComponent implements OnChanges {
  @Input() filters: KpiFilters = {};

  loading = false;

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      { label: 'Dev', data: [], backgroundColor: '#93c5fd' },
      { label: 'QA', data: [], backgroundColor: '#fbbf24' },
      { label: 'Prod Manuel', data: [], backgroundColor: '#34d399' },
      { label: 'Prod Automatisé', data: [], backgroundColor: '#6366f1' },
    ],
  };

  chartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    plugins: { legend: { position: 'top' } },
    scales: {
      x: { stacked: true },
      y: { stacked: true, beginAtZero: true },
    },
  };

  constructor(private kpiService: KpiService) {}

  ngOnChanges(_changes: SimpleChanges): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.kpiService.getStageDistribution(this.filters).subscribe({
      next: (response) => {
        this.chartData = {
          labels: response.dataPoints.map((p) =>
            new Date(p.snapshotDate).toLocaleDateString(),
          ),
          datasets: [
            {
              label: 'Dev',
              data: response.dataPoints.map((p) => p.dev),
              backgroundColor: '#93c5fd',
            },
            {
              label: 'QA',
              data: response.dataPoints.map((p) => p.qa),
              backgroundColor: '#fbbf24',
            },
            {
              label: 'Prod Manuel',
              data: response.dataPoints.map((p) => p.prodManual),
              backgroundColor: '#34d399',
            },
            {
              label: 'Prod Automatisé',
              data: response.dataPoints.map((p) => p.prodAutomated),
              backgroundColor: '#6366f1',
            },
          ],
        };
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
